<script setup lang="ts">
import { DIALOG_OVERLAY_OPACITY } from '@/constants/practiceConstants'

interface Props {
  visible: boolean
  percent: number
  onClick: (() => void) | null
}

const props = withDefaults(defineProps<Props>(), {
  onClick: null,
})
</script>

<template>
  <v-dialog max-width="420" :model-value="visible" :opacity="DIALOG_OVERLAY_OPACITY" persistent>
    <v-card>
      <v-card-title class="text-h6 pt-5 px-6">Calibrating background noise</v-card-title>
      <v-card-text class="px-6 pb-5">
        <p class="text-body-2 text-medium-emphasis mb-4">Please remain silent during calibration.</p>
        <v-progress-linear class="mb-4" color="primary" height="6" :model-value="percent" rounded />
        <div class="d-flex justify-end">
          <v-btn variant="plain" @click="props.onClick?.()">Cancel</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
